/**
 * ? @description : Mapped Tab
 */

// Dependencies
import React, { useState, useEffect } from "react";
import MUIDataTable, { TableFilterList } from "mui-datatables";
import { Dropdown } from "react-bootstrap";
import { useDispatch } from "react-redux";
import Chip from "@material-ui/core/Chip";
import { CircularProgress, Typography } from "@mui/material";

// MUI Icons
import MoreVertIcon from "@mui/icons-material/MoreVert";

// Components
import MappedModalDelete from "./modals/MappedModalDelete";
import CommentsModal from "../../../Reusable/CommentsModalReuse";

// Axios Component
import Axios from "../../../../axios/Axios";

// Redux Component
import { showSnackbar } from "../../../redux/features/appSlice";
import { ShowFullText } from "../../../Reusable/ShowMoreText";
import axios from "axios";

import { LibraryBooks } from "@mui/icons-material";
import CloseIcon from '@mui/icons-material/Close';
// chat box module 
import {
  MainContainer,
  ChatContainer,
  MessageList,
  Message,
  ConversationHeader,
  Conversation,
} from "@chatscope/chat-ui-kit-react";
import { Modal } from "react-bootstrap";
import io from 'socket.io-client';
import { IconButton } from "@mui/material";


function MappedTab() {
  // * Redux
  const dispatch = useDispatch();

  // * State Variables
  const [data, setData] = useState([]);
  const [mappedData, setMappedData] = useState([]);
  const [deleteModal, setDeleteModal] = useState(false);
  const [commentModal, setCommentModal] = useState(false);
  const [isDataFetchError, setIsDataFetchError] = useState(false);

  // for chat ui card
  const [openChatBox, setOpenChatBox] = useState(false);
  const [chatBoxTeacherData, setChatBoxTeacherData] = useState({
    teacherId: '',
    teacherName: '',
    // teacherStatus: '',
    spoc_id: '',
  });
  // const inputRef = useRef(null);

  // for comment section 
  const [reloadComments, setReloadComments] = useState(false);
  const handleCommentsModalClose = () => {
    setReloadComments(!reloadComments);
  };
  // for pagination state 
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const handleRowsPerPageChange = (newRowsPerPage) => {
    setRowsPerPage(newRowsPerPage);
  };


  // for chat messages card

  function ChartBox({ open, onClose, spoc_id, teacherId, teacherName }) {
    // const [socket, setSocket] = useState(null);
    // const [message, setMessage] = useState('');
    const [messages, setMessages] = useState([]);
    // console.log(spoc_id, teacherId);

    // * Function Call previous chat message
    useEffect(() => {
      const controller = axios.CancelToken.source();
      if (spoc_id && teacherId) {
        (async () => {
          try {
            let finalData = {
              spoc_id: spoc_id,
              teacher_id: teacherId
            };
    
            const options = {
              method: "post",
              url: `/messages/chat`,
              auth: true,
              data: finalData,
              token: { cancelToken: controller.token }
            };
    
            const readOptions = {
              method: "put",
              url: `/messages/update/chat/admin/read/status`,
              auth: true,
              data: finalData,
              token: { cancelToken: controller.token }
            };
    
            let [response, responseReadOptions] = await Promise.all([
              Axios(options.method, options.url, options.auth, options.data, options.token),
              Axios(readOptions.method, readOptions.url, readOptions.auth, readOptions.data, readOptions.token)
            ]);
    
            if (response.status === 200 && responseReadOptions.status === 200) {
              setMessages(response.data);
            }
    
          } catch (error) {
            if (!axios.isCancel(error)) {
              console.error(error);
            }
          }
        })();
      }
    
      return () => {
        controller.cancel();
      };
    }, [spoc_id, teacherId]);


    useEffect(() => {

      if (spoc_id && teacherId) {

        const newSocket = io('https://staginglteapi.letsteachenglishact.org', {
          reconnectionDelayMax: 10000,
        }); // Connect to the backend
        // setSocket(newSocket);
        // console.log(spoc_id, teacherId, 'spoc_id, teacherId- line 107,');
        // Join the room based on spocId and teacherId
        newSocket.emit('joinRoom', { spoc_id: spoc_id, teacher_id: teacherId });

        // Listen for messages from the server
        newSocket.on('message', (data) => {
          setMessages((prevMessages) => [...prevMessages, data]); // Append new message to the chat

        });

        // Cleanup when the component is unmounted
        return () => {
          newSocket.disconnect();
        };
      }

    }, [teacherId , open , spoc_id]);

    // const sendMessage = () => {
   
    //   if (message && socket) {
   
    //     socket.emit('message', { spoc_id: spoc_id, teacher_id: teacherId, message, sender: 'spoc' });


    //     setMessage('');
    //   }
    //   inputRef.current?.focus();
    // };

    return (
      <Modal show={open}
        size="l"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        style={{ zIndex: 2000, position: 'fixed', }}
        onHide={onClose}
      >
        <div style={{ position: "relative", height: "400px" }}>
          <MainContainer>
            <ChatContainer>
              <ConversationHeader>
                {/* <Avatar
        name="Akane"
        src={}
      /> */}
                {/* <Status  size="lg" status="available" /> */}

                <ConversationHeader.Content
                  // info={teacherStatus === 'active' ? 'Active' : 'Drop'}
                  userName={teacherName}

                />

                <ConversationHeader.Actions>
                  <CloseIcon
                    onClick={onClose}
                  />
                </ConversationHeader.Actions>
              </ConversationHeader>
              <MessageList>


                {messages && messages.length > 0 ? (messages.map((msg, index) => {
                  console.log(msg);
                  return (
                    <>
                      {msg.sender === 'spoc' ? (

                        <Message
                          key={index}
                          model={{
                            direction: 'outgoing',
                            message: msg.message,  // Assuming 'msg' contains 'text' property
                            sentTime: msg.sentTime || "just now", // Use sent time if available
                            sender: msg.sender || 'Server', // Placeholder for sender
                          }}
                        />

                      ) : (


                        <Message
                          key={index}
                          model={{
                            direction: 'incoming',
                            message: msg.message,  // Assuming 'msg' contains 'text' property
                            sentTime: msg.sentTime || "just now", // Use sent time if available
                            sender: msg.sender || 'Server', // Placeholder for sender
                          }}
                        />
                      )}
                    </>


                  )
                })) : (
                  <Message
                    model={{
                      direction: 'outgoing',
                      message: 'No messages yet. Start the conversation!',
                      sentTime: 'just now',
                      sender: 'System', // Can use any default sender name
                    }}
                  />
                )}

              </MessageList>
              {/* <MessageInput
                  ref={inputRef}
                  attachButton={false}
                  placeholder="Type message here"
                  value={message}
                  onChange={setMessage}
                  onSend={sendMessage}
                /> */}
            </ChatContainer>
          </MainContainer>
        </div>

      </Modal>

    )
  }



  // * Columns Declaration for Table
  const columns = [
    {
      name: "map_id",
      label: "Mapped Id",
      options: {
        display: false,
        filter: false,
        filterType: "dropdown",
        sort: true,
        sortDirection: "desc"
      },
    },
    {
      name: "teacher_id",
      label: "Teacher Id",
      options: {
        display: false,
        filter: false,
        filterType: "dropdown",
      },
    },
    {
      name: "teacher_name",
      label: "Teacher Name",
      options: {
        filter: false,
        filterType: "dropdown",
      },
    },
    {
      name: "student_id",
      label: "Student Id",
      options: {
        display: false,
        filter: false,
        filterType: "dropdown",
      },
    },
    {
      name: "student_name",
      label: "Student Name",
      options: {
        filter: false,
        filterType: "dropdown",
      },
    },
    // {
    //   name: "batch_id",
    //   label: "Batch Id",
    //   options: {
    //     filter: false,
    //     filterType: "dropdown",
    //   },
    // },
    // {
    //   name: "batch_name",
    //   label: "Batch Name",
    //   options: {
    //     filter: true,
    //     filterType: "dropdown",
    //   },
    // },
    {
      name: "spoc_id",
      label: "SPOC Id",
      options: {
        filter: false,
        filterType: "dropdown",
        display: false,
      },
    },
    {
      name: "spoc_name",
      label: "SPOC Name",
      options: {
        filter: true,
        filterType: "dropdown",
      },
    },
    {
      name: "comment_desc",
      label: "Comments",
      options: {
        filter: true,
        filterType: "dropdown",
        customBodyRender: (value) => {
          // console.log(value);
          return (
            <ShowFullText title={value}>
              <Typography variant='p' sx={{ cursor: 'pointer' }}>
                {value && value.length > 25 ? `${value.substring(0, 25)}...` : value}
              </Typography>
            </ShowFullText>
          )
        }
      },
    },
    // {
    //   name: 'admin_unread_status_count',
    //   label: "Chat Box",
    //   options: {
    //     filter: false,
    //     sort: false,
    //     customBodyRender: (_, data) => {
    //       // let studentId = data.rowData[3]
    //       let teacherId = data.rowData[1]
    //       // // console.log(data.rowData);
    //       let teacherName = data.rowData[2]
    //       let spocId = data.rowData[5]
    //       let unreadCount = data.rowData[8]
    //       return (
    //         <IconButton
    //           onClick={() => {
    //             setOpenChatBox(true)
    //             setChatBoxTeacherData({
    //               teacherId: teacherId,
    //               teacherName: teacherName,
    //               spoc_id: spocId,
    //             })
    //             // if (spocId & teacherId) {
    //             //   setOpenChatBox(true)
    //             //   setChatBoxTeacherData({
    //             //     teacherId: teacherId,
    //             //     teacherName: teacherName,
    //             //     spoc_id: spocId,
    //             //   })
    //             // }

    //           }}
    //         >
    //           <Conversation
    //             unreadCnt={unreadCount}
    //           >
    //             <Conversation.Operations visible>
    //               <LibraryBooks color="primary"></LibraryBooks>
    //             </Conversation.Operations>
    //           </Conversation>
    //         </IconButton>
    //       );
    //     },
    //   },
    // },
    {
      name: "ACTIONS",
      options: {
        filter: false,
        sort: false,
        customBodyRenderLite: () => {
          return (
            <div>
              <Dropdown>
                <Dropdown.Toggle
                  variant="primary rounded-circle"
                  id="dropdown-basic"
                >
                  <MoreVertIcon />
                </Dropdown.Toggle>

                <Dropdown.Menu>
                  <Dropdown.Item href="#" onClick={() => setCommentModal(true)}>
                    Create / View comment
                  </Dropdown.Item>
                  <Dropdown.Item href="#" onClick={() => setDeleteModal(true)}>
                    Unmap
                  </Dropdown.Item>
                </Dropdown.Menu>
              </Dropdown>
            </div>
          );
        },
      },
    },
  ];


  // * Function Call
  useEffect(() => {
    // ? Get Method : Get Mapped Data from Server
    const controller = axios.CancelToken.source();
    (async () => {
      try {
        let options = {
          method: "GET",
          url: "/mapping",
          auth: true,
          data: null,
          token: { cancelToken: controller.token }
        };

        const response = await Axios(
          options.method,
          options.url,
          options.auth,
          options.data,
          options.token,
        );
        response.status === 200 && response.data.length !== 0 ? setMappedData(response.data) : setIsDataFetchError(true)

      } catch (error) {
        if (!axios.isCancel(error)) {
          setIsDataFetchError(true)
          dispatch(
            showSnackbar({
              message: "Unable to get mapped data.",
              severity: "error",
            })
          );
        }
      }
    })()
    return () => {
      controller.cancel();
    }
  }, [dispatch, reloadComments, rowsPerPage]);

  // * Options Configuration for Table
  const options = {
    textLabels: {
      body: {
        noMatch: isDataFetchError ? "Sorry, No Data available" : <CircularProgress />,
      }
    },
    filter: true,
    filterType: "dropdown",
    responsive: "standard",
    elevation: 0,
    rowsPerPage: rowsPerPage,
    rowsPerPageOptions: [5, 10, 20],
    onChangeRowsPerPage: handleRowsPerPageChange,
    fixedHeader: true,
    fixedSelectColumn: true,
    tableBodyHeight: "auto",
    jumpToPage: true,
    onRowClick: (rowData, rowState) => {
      setData(rowData);
    },
    customSearch: (searchQuery, currentRow, columns) => {
      currentRow.forEach(col => {
        if (col && col.toString().indexOf(searchQuery) >= 0) {
          return setIsDataFetchError(true);
        }
      });
    }
  };

  const CustomChip = ({ label, onDelete }) => {
    return (
      <Chip
        variant="outlined"
        color="secondary"
        label={label}
        onDelete={onDelete}
      />
    );
  };

  const CustomFilterList = (props) => {
    return <TableFilterList {...props} ItemComponent={CustomChip} />;
  };

  return (
    <div style={{ padding: "10px" }}>
      {/* Table */}
      <MUIDataTable
        title={"Mapped Data"}
        data={mappedData}
        columns={columns}
        options={options}
        components={{
          TableFilterList: CustomFilterList,
        }}
      />

      {/* Modal */}
      <MappedModalDelete
        show={deleteModal}
        onHide={() => setDeleteModal(false)}
        tabledata={data}
        onCloseCallback={handleCommentsModalClose}
      />

      {/*Comments modal*/}
      <CommentsModal
        show={commentModal}
        onHide={() => setCommentModal(false)}
        // commentstomodal={tableData}
        tabledata={data}
        modalname="mappingcomments"
        postcomment={"comments/map"}
        getcomment={"comments/map/mapping/"}
        onCloseCallback={handleCommentsModalClose}
      />
      <ChartBox
        open={openChatBox}
        onClose={() => {
          setOpenChatBox(false)
          setChatBoxTeacherData({
            teacherId: '',
            teacherName: '',
            // teacherStatus: '',
            spoc_id: '',
          })
          handleCommentsModalClose()
        }}
        spoc_id={chatBoxTeacherData.spoc_id}
        teacherId={chatBoxTeacherData.teacherId}
        teacherName={chatBoxTeacherData.teacherName}
      // teacherStatus={chatBoxTeacherData.teacherStatus}
      />
    </div>
  );
}

export default MappedTab;
